import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import AdvForm from '../../../../CommonComponents/AdvForm';
import { inputTextChanged } from '../../../../Profile/Accounts_react/AccountsUtils';
import { isNumeric } from '../../../../../js/app/react/validators';
import { BACKEND_DECUMULATION_GOAL_API } from '../../DecumulationWorkflow.constants';
import InputAge from '../../../InputAge/InputAgeView';

const validator = value => () =>
  isNumeric(value) && +value > 0 ? [] : ['Please enter a valid value'];

const DistributionYearsView = ({
  workflowId,
  branch,
  clientId,
  store,
  distributionYears,
  doNotSave,
}) => (
  <AdvWorkflowStep branch={branch} workflowId={workflowId}>
    <Validation
      workflowId={workflowId}
      validationId={`${BACKEND_DECUMULATION_GOAL_API}.DistributionYears`}
    />

    <h2>How many years will you take distributions?</h2>

    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputAge
            maxLength={3}
            isUnder
            placeholderClassName="adv-workflows-placeholder-large"
            placeholder="Year(s)"
            className="xsm text-center"
            value={distributionYears}
            id="adv-years"
            onChange={inputTextChanged(
              clientId,
              store(workflowId),
              `${BACKEND_DECUMULATION_GOAL_API}.DistributionYears`,
            )}
          />
        </li>
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={validator(distributionYears)}
      validationId={`${BACKEND_DECUMULATION_GOAL_API}.DistributionYears`}
      workflowId={workflowId}
      backendKey={BACKEND_DECUMULATION_GOAL_API}
      doNotSave={doNotSave}
    />
  </AdvWorkflowStep>
);

DistributionYearsView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  store: PropTypes.func.isRequired,
  distributionYears: PropTypes.oneOf([PropTypes.number, null]).isRequired,
  doNotSave: PropTypes.bool.isRequired,
};

export default DistributionYearsView;
